const MODAL_STEPS = {
  TRY_FULL_VERIFICATION: 'try_full_verification',
  SELFIE_FAILED: 'selfie_failed',
  SUCCESS: 'success',
  DETAILS: 'details',
};

const FACE_AUTH_ENROLL_ERROR_CODE = {
  FAILED_ATTEMPTS_LIMIT_REACHED: 'failed_attempts_limit_reached',
};

const OPEN_MODAL_QUERY_PARAM = 'rekyc_details_modal';

enum ADDRESS_UPDATE_STATUS {
  SHOW_SUCCESS = 'show_success',
  CLOSED_SUCCESS = 'closed_success',
  NOT_STARTED = 'not_started',
  FAILED = 'failed',
  REFRESHED_POST_SUCCESS = 'refreshed_post_success',
}

export {
  MODAL_STEPS,
  FACE_AUTH_ENROLL_ERROR_CODE,
  OPEN_MODAL_QUERY_PARAM,
  ADDRESS_UPDATE_STATUS,
};
